// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"b5caee56","1486":"b5caee56","1599":"b5caee56","3575":"ce044c50","6782":"b5caee56"}[chunkId] + ".chunk.css";
};